<div
    [pandoraOnClickOutside]="close.bind(this)"
    class="relative mt-2 w-full"
>
    <button
        (click)="toggle()"
        type="button"
        class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6"
    >
        <span class="block truncate">
            {{ selectedOption?.label }}
        </span>
        <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-400">
            <app-icon [icon]="chevronIcon" size="table" />
        </span>
    </button>
    @if (open()) {
        <div class="absolute z-10 mt-1 p-2 space-y-2 rounded-md bg-white overflow-hidden shadow-lg w-full ring-1 ring-black ring-opacity-5 focus:outline-none">
            <ul class="max-h-60 overflow-auto text-base sm:text-sm"
                tabindex="-1">
                @for (option of options; track option) {
                    <li
                        role="button"
                        tabindex="0"
                        (keydown.enter)="select(option)"
                        (keydown.space)="$event.preventDefault(); select(option)"
                        (click)="select(option)"
                        class="cursor-pointer select-none"
                    >
                        <div class="text-gray-900 rounded-md overflow-hidden hover:bg-gray-100 py-3 px-4 flex justify-between items-center">
                            <div
                                class="block truncate"
                                [class.font-semibold]="option.value === value()"
                            >
                                {{ option.label }}
                            </div>
                            @if (option.value === value()) {
                                <app-icon [icon]="checkIcon" size="table" class="text-action" />
                            }
                        </div>
                    </li>
                }
            </ul>
            <ng-content select="[footer]" />
        </div>
    }
</div>
